import { useEffect, useState } from "react"
import { simpleGetter } from "../actions/common"
import { mainApi, userApi } from "../api/api"
import { MainUserJsonSavedData } from "../types"

export const useMainOrganizations = () => {
    const [data, setData] = useState([])

    const fetchData = async () => {
        const response = await simpleGetter(mainApi.getOrganizations)
        if (response.organizations) {
            setData(response.organizations)
        }
    }

    useEffect(() => {
        fetchData();
    }, [])

    return data;
}

export const useMainOrganizationSearch = (organizationId: number, query: string, reset: number, source: string = 'external'): [MainUserJsonSavedData[], boolean] => {
    const [data, setData] = useState<MainUserJsonSavedData[]>([])
    const [loading, setLoading] = useState(false);
    const fetchData = async () => {
        setLoading(true);
        let response
        if (source === "external") {
            response = await simpleGetter(mainApi.searchInOrganization, {
                organizationId,
                query
            });
        } else {
            response = await simpleGetter(userApi.searchByEmail, query)
        }
        setLoading(false);
        if (response.users) {
            setData(response.users);
        }
    }

    useEffect(() => {
        if (query?.length >= 3 && (source === "internal" || organizationId)) {
            fetchData();
        }
    }, [organizationId, query])

    useEffect(() => {
        setData([])
    }, [reset])

    return [data, loading];
}